<template>
  <section
    class="flex items-center justify-between lg:flex-row flex-col gap-10"
  >
    <div class="relative w-full xl:w-1/2 space-y-10">
      <div class="flex flex-col gap-4 md:gap-6">
        <h1
          class="text-[28px] leading-[28px] md:text-[48px] md:leading-[48px] font-semibold"
        >
          {{ $t("landing.aboutHero.title") }}
        </h1>
        <p
          class="md:text-base text-sm"
          v-html="$t('landing.aboutHero.description')"
        />
        <p class="md:text-base text-sm font-openSans">
          {{ $t("landing.aboutHero.description2") }}
        </p>
      </div>
      <RouterLink to="/auth/register" class="relative block">
        <Button
          class="text-white bg-primary rounded-full px-6 py-3"
          :text="$t('landing.links.sign_up')"
        />
      </RouterLink>
    </div>
    <div
      class="relative flex-y-center justify-center w-full xl:w-1/2 space-y-10"
    >
      <img
        src="/landing/logo/logo.webp"
        alt="Saraf Robot Logo"
        class="w-[300px]"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import Button from "@/modules/Landing/components/Base/Button/Button.vue";
</script>

<style scoped></style>
